import { useLanguage } from '@/lib/i18n';
import { useTranslation } from 'react-i18next';

/**
 * Language Switcher Component
 *
 * Provides a simple UI for switching between available languages.
 * Persists language selection to localStorage.
 *
 * @example
 * ```tsx
 * // In Header or Settings
 * <LanguageSwitcher />
 * ```
 */
export function LanguageSwitcher() {
  const { language, changeLanguage, languages } = useLanguage();
  const { t } = useTranslation('common');

  return (
    <div className="flex items-center gap-2">
      {languages.map((lang) => (
        <button
          key={lang}
          onClick={() => changeLanguage(lang)}
          className={`
            px-3 py-1 text-sm font-medium rounded-md transition-colors
            ${
              language === lang
                ? 'bg-primary text-primary-foreground'
                : 'bg-secondary text-secondary-foreground hover:bg-secondary/80'
            }
          `}
          aria-label={t('languageSwitcher.switchTo', { language: lang.toUpperCase() })}
        >
          {lang.toUpperCase()}
        </button>
      ))}
    </div>
  );
}
